import { ComponentPropsWithoutRef } from 'react';
import { mergeClasses } from '../../../helpers/merge-classes';
import { NakedButton } from '../../../naked/naked-button.component';
import { useCalendarState } from '../provider/calendar.provider';
import { getDecadeRange } from '../provider/reducer/calendar-utils';
import type { BaseAtomProps } from './calendar-atom.types';

type Props = BaseAtomProps & {
  year: number;
};

type CalendarYearsProps = Props & Omit<ComponentPropsWithoutRef<'div'>, keyof Props>;

export const CalendarYears = ({ className, year: focusedYear, ...rest }: CalendarYearsProps) => {
  const { getYearButtonProps } = useCalendarState();
  return (
    <div className={mergeClasses('calendar__months__years', className)} {...rest}>
      {getDecadeRange(focusedYear).map((year, index) => (
        <NakedButton key={year} className='cal__months' type='button' {...getYearButtonProps(String(year), index)}>
          {year}
        </NakedButton>
      ))}
    </div>
  );
};
